import { render, staticRenderFns } from "./custosFixosEditar.vue?vue&type=template&id=5e259662&scoped=true&"
import script from "./custosFixosEditar.vue?vue&type=script&lang=js&"
export * from "./custosFixosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e259662",
  null
  
)

export default component.exports